<template>
  <div class="login-container">
    <van-loading v-if="loading" size="24px" vertical>登录中...</van-loading>
  </div>
</template>

<script>
import DingtalkService from '@/api/dingtalk/DingtalkService.js'
import Vue from "vue";
import * as dd from "dingtalk-jsapi";

export default {
  data() {
    return {
      loading: false,
      loginTimer: null,
      isReloading: false,
      hasReloaded: false
    }
  },
  mounted() {
    this.reloadDingtalkEnvironment()
  },
  beforeDestroy() {
    if (this.loginTimer) {
      clearTimeout(this.loginTimer)
    }
  },
  methods: {
    reloadDingtalkEnvironment() {
      const reloadKey = 'dingtalk_login_reloaded_' + this.getQueryVariable('corpId')
      const hasReloaded = localStorage.getItem(reloadKey)

      if (hasReloaded) {
        localStorage.removeItem(reloadKey)
        this.executeLogin()
        return
      }

      this.loading = true
      localStorage.setItem(reloadKey, 'true')
      window.location.reload()
    },
    executeLogin() {
      if (this.isReloading) {
        return
      }

      this.loading = true

      Vue.cookie.delete('token')
      Vue.cookie.delete('pm-token')
      // Vue.cookie.delete('date');
      Vue.cookie.delete('name');
      Vue.cookie.delete('userId');
      Vue.cookie.delete('sjplsp')
      Vue.cookie.delete('searchValue')
      Vue.cookie.delete('searchTitle')
      Vue.cookie.delete('searchTitleId')
      Vue.cookie.delete('todoSearchValue')
      Vue.cookie.delete('doneSearchValue')
      Vue.cookie.delete('sponsorSearchValue')
      localStorage.removeItem('current')
      localStorage.removeItem('scrollTopPosition')
      localStorage.removeItem('size')
      localStorage.removeItem('SponsorCurrent')
      localStorage.removeItem('scrollSponsorPosition')
      localStorage.removeItem('SponsorSize')
      localStorage.removeItem('DoneCurrent')
      localStorage.removeItem('scrollDonePosition')
      localStorage.removeItem('DoneSize')
      localStorage.removeItem('tabbarName')
      localStorage.removeItem('category')
      localStorage.removeItem('businessTable')
      localStorage.removeItem('businessName')

      let corpId = this.getQueryVariable('corpId')
      let loginSuccess = false

      const loginTimeout = setTimeout(() => {
        if (!loginSuccess && !this.isReloading) {
          this.isReloading = true
          this.loading = false
          this.$toast.fail('登录超时，请手动刷新页面重试')
        }
      }, 10000)

      this.loginTimer = loginTimeout

      const doLogin = () => {
        dd.runtime.permission.requestAuthCode({
          corpId: corpId,
          onSuccess: (result) => {
            new DingtalkService().dingtalkLogin(result.code, corpId).then(({data}) => {
              if(data.code === 200) {
                Vue.cookie.set('token', data.token);
                // Vue.cookie.set('date', data.date);
                Vue.cookie.set('name', data.name);
                Vue.cookie.set('userId', data.userId);
                Vue.cookie.set('sjplsp', data.sjplsp);
                loginSuccess = true
                clearTimeout(loginTimeout)
                this.loading = false
                this.$router.replace('/dailyLog/index')
              } else {
                this.$toast.fail(data.message)
              }
            }).catch(err => {
              clearTimeout(loginTimeout)
              this.loading = false
              this.$toast.fail('登录失败，请手动刷新页面重试')
            })
          },
          onFail: (err) => {
            clearTimeout(loginTimeout)
            this.loading = false
            this.$toast.fail('获取授权码失败，请手动刷新页面重试')
          }
        })
      }

      if (dd.version) {
        doLogin()
      } else {
        dd.ready(() => {
          doLogin()
        })
        dd.error((err) => {
          clearTimeout(loginTimeout)
          this.loading = false
          this.$toast.fail('钉钉环境初始化失败，请手动刷新页面重试')
        })
      }
    },
    getQueryVariable(variable) {
      var query = window.location.href.split("?")[1]
      if (!query) return false
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    }
  }
}
</script>

<style>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}
</style>
